<template>
    <div id="about">
        <div class="div-block-4"></div>
        <div data-collapse="medium" data-animation="default" data-duration="400" class="header-navigation fixed w-nav">
            <NetworkStatus/>
            <HeaderMenu/>
        </div>

        <div>
            <div class="section section-color center">
                <div class="w-container" style="padding:50px 0 0 0">
                    <h1 class="key-number">LocalScale for Nonprofits</h1>
                </div>
            </div>

            <div class="center" style="margin:20px 30px">
                <div class="industry-container">
                    <div class="industry-text">
                        <p style="font-size: 18px;font-weight:bold">Empower your nonprofit organization to make a greater impact with LocalScale, your ally in targeted advertising for community support</p>
                        <p>As a nonprofit, building strong relationships with potential donors and supporters is essential for fulfilling your mission.</p>
                        <p>With LocalScale, you can enhance your organization's visibility and connect with individuals who are passionate about your cause.</p>
                        <p>Whether you're raising awareness for a specific campaign, recruiting volunteers, or seeking donations, our precision-targeted ad network enables you to reach community members who share your values and want to make a difference.</p>
                        <p>By leveraging LocalScale, you can amplify your nonprofit's message, expand your donor base, and increase your organization's impact in the community.</p>
                        <p>Let us help you strengthen your connections and drive positive change for the causes you care about.</p>
                        <div class="button-group" style="margin-top: 20px;margin-bottom: 10px;">
                            <div class="navigation-action"><a href="signup.html" class="ds-button button-small w-button">{{$t('get_started')}}</a></div>
                        </div>
                    </div>
                    <div class="industry-image">
                        <img src="images/industry-nonprofit.png" alt="Nonprofit">
                    </div>
                </div>
            </div>

            <div style="width: 100%;background-color:#e6faf6;">
                <div class="testimonial">
                    <div class="testimonial-stars">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                    </div>
                    <h3 class="testimonial-quote">“LocalScale has been an invaluable partner for our nonprofit organization. Their targeted advertising solutions have helped us reach a wider audience of potential supporters and donors who are passionate about our cause. Thanks to LocalScale, we've been able to increase awareness for our mission and attract more community members to join our efforts.”</h3>
                    <p class="testimonial-customer">– Michael Patel, Executive Director at Hopeful Hearts Foundation</p>
                </div>
            </div>

            <Plans :what_are_you_waiting_for="true"/>
        </div>

        <Footer/>

    </div>
</template>

<script>
import HeaderMenu from "../components/HeaderMenu";
import NetworkStatus from "../components/NetworkStatus.vue";
import Footer from "../components/Footer";
import Plans from "../components/Plans";

export default {
    components: {
        HeaderMenu, NetworkStatus, Footer, Plans
    }
}
</script>

<style>
body {
    font-family: Inter, sans-serif;
    background-color: #fff;
}
p {
    color: black;
    margin: 10px;
    font-size: 16px;
}
h2 {
    text-align: center;
}
a {
    text-decoration: none;
    color: #1f1f1f
}
</style>
